import React, { useState, useEffect, useContext, useRef } from "react";
import UserServices from "../../UserServices/UserServices";
import useSortableData from "../../hooks/useSortableData";
import { Link } from "react-router-dom";
import { NoteState } from "../../context/notes/NoteState";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import MenuButton from "../MenuButton/MenuButton";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import $ from "jquery";
import CurrencyFormat from "react-currency-format";

// Validation schema
const charitySchema = Yup.object({
  branch_id: Yup.string().required("Branch is required"),
  date: Yup.date().required("Date is required"),
  type: Yup.string().required("Transaction type is required"),
  person: Yup.string().required("Person is required"),
  amount: Yup.number()
    .required("Amount is required")
    .min(1, "Amount must be greater than 0"),
  notes: Yup.string(),
});

export default function GetCharity() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;
  const [myData, setMyData] = useState([]);
  const [openingBalance, setOpeningBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const date = new Date();
  const defaultValue = date.toLocaleDateString("en-CA");
  const dateSelected = moment(defaultValue).format("YYYY-MM-DD");
  const strtDate = moment().startOf("month").format("YYYY-MM-DD");

  const [startDate, setStartDate] = useState(strtDate);
  const [endDate, setEndDate] = useState(dateSelected);
  const [DAteSeted, setDAteSeted] = useState(false);
  
  // Update modal states
  const [myBranches, setMyBranches] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [packageId, setPackageId] = useState("");
  
  const clickEvent = $.Event("click");
  const closeButtonRef = useRef(null);

  const fetchBranches = async () => {
    try {
      const response = await UserServices.branchName();
      const res = response.data.data;
      const branches = res.map((b) => ({ id: b.id, name: b.name }));
      setMyBranches([{ id: "", name: "Select Branch" }, ...branches]);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCharityRecords = async (values) => {
    if (Date.parse(values.sdate) <= Date.parse(values.edate)) {
      setLoading(true);
      try {
        const response = await UserServices.getCharity(branch_id, {
          start_date: values.sdate,
          end_date: values.edate,
        });

        if (response.status === 200) {
          const data = response.data.data || [];
          const opening = response.data.opening_balance || {
            f_balance: 0,
            w_balance: 0,
            total_balance: 0,
            date: null,
          };

          setMyData(data);
          setOpeningBalance(opening);
        }
      } catch (err) {
        console.error(err);
        setMyData([]);
        setOpeningBalance({
          f_balance: 0,
          w_balance: 0,
          total_balance: 0,
          date: null,
        });
        toast.error("Failed to fetch charity records", { autoClose: 3000 });
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("End date should be greater than start date!", {
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    fetchBranches();
    fetchCharityRecords({ sdate: startDate, edate: endDate });
  }, []);

  const getRecordDetails = async (id) => {
    setLoading(true);
    try {
      const response = await UserServices.getCharity(branch_id, {
        start_date: startDate,
        end_date: endDate,
      });
      
      if (response.status === 200) {
        const record = response.data.data.find((r) => r.id === id);
        if (record) {
          setSelectedRecord({
            branch_id: record.branch_id,
            date: record.date,
            type: record.credit > 0 ? "Credit" : "Debit",
            person: record.to || record.from,
            amount: record.credit > 0 ? record.credit : record.debit,
            notes: record.notes || "",
          });
          setPackageId(id);
          $("#charityModal").trigger(clickEvent);
        }
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch record details", { autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  const deleteRecord = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this record?");
    if (!confirmed) return;

    try {
      const response = await UserServices.deleteCharity(id);
      if (response.status === 204) {
        toast.success("Deleted Successfully!", { autoClose: 3000 });
        fetchCharityRecords({ sdate: startDate, edate: endDate });
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete record", { autoClose: 3000 });
    }
  };

  const setDates = async (param) => {
    setDAteSeted(true);
    try {
      const response = await UserServices.getStartEndDates(param);
      if (response.status === 200) {
        setStartDate(response.data.StartDate);
        setEndDate(response.data.EndDate);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setDAteSeted(false);
    }
  };

  const Table = ({ data }) => {
    const { items, requestSort, sortConfig } = useSortableData(data);
    const getClassNamesFor = (name) =>
      sortConfig?.key === name ? sortConfig.direction : undefined;

    let fBalance = openingBalance?.f_balance || 0;
    let wBalance = openingBalance?.w_balance || 0;

    const generatePdf = () => {
      const doc = new jsPDF("p", "mm", "letter");
      const table = document.getElementById("charity-table");
      
      doc.text("Charity Ledger", 10, 10);
      const tableOptions = {
        headStyles: { fillColor: [232, 0, 43], textColor: 255 },
        styles: { fontSize: 5 },
      };
      
      doc.autoTable({
        html: table,
        startY: 15,
        ...tableOptions,
      });

      doc.save("Charity_Ledger.pdf");
    };

    return (
      <>
        <div className="card">
          <div className="card-header py-3">
            <div className="row">
              <div className="col-md-6">
                <h5 className="mb-0 font-20">Charity Ledger</h5>
              </div>
              <div className="col-md-6 text-end">
                <button
                  className="btn btn-primary mx-2"
                  onClick={generatePdf}
                >
                  <i className="bi bi-file-earmark-pdf"></i> PDF
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table
                className="table table-striped table-borderless table-style-1"
                id="charity-table"
              >
                <thead>
                  <tr>
                    <th scope="col">Sr#</th>
                    <th
                      scope="col"
                      onClick={() => requestSort("date")}
                      className={getClassNamesFor("date")}
                    >
                      Date
                    </th>
                    <th scope="col">Notes</th>
                    <th scope="col">Credit To</th>
                    <th scope="col">Credit</th>
                    <th scope="col">Debit From</th>
                    <th scope="col">Debit</th>
                    <th scope="col">Faisal Balance</th>
                    <th scope="col">Sir Waqas Balance</th>
                    <th scope="col">Total Charity</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Opening Balance Row */}
                  {openingBalance && (
                    <tr className="table-warning">
                      <td>1</td>
                      <td>{openingBalance.date ? moment(openingBalance.date).format("DD-MM-YYYY") : "-"}</td>
                      <td>Opening Balance</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>
                        <CurrencyFormat
                          value={openingBalance.f_balance}
                          displayType="text"
                          thousandSeparator
                          prefix="Rs "
                          suffix="/-"
                        />
                      </td>
                        <td>
                        <CurrencyFormat
                            value={openingBalance.w_balance}
                          displayType="text"
                          thousandSeparator
                          prefix="Rs "
                          suffix="/-"
                        />
                      </td>
                      <td>
                        <CurrencyFormat
                          value={openingBalance.total_balance}
                          displayType="text"
                          thousandSeparator
                          prefix="Rs "
                          suffix="/-"
                        />
                      </td>
                      <td>-</td>
                    </tr>
                  )}

                  {/* Data Rows */}
                  {items.length ? (
                    items.map((el, index) => {
                      // Update running balances
                      if (el.to === "Faisal") {
                        fBalance += parseFloat(el.credit || 0);
                      } else if (el.to === "Waqas") {
                        wBalance += parseFloat(el.credit || 0);
                      }
                      
                      if (el.from === "Faisal") {
                        fBalance -= parseFloat(el.debit || 0);
                      } else if (el.from === "Waqas") {
                        wBalance -= parseFloat(el.debit || 0);
                      }

                      const totalBalance = fBalance + wBalance;

                      // Check if it's a transfer (both credit and debit are same)
                      const isTransfer = el.credit > 0 && el.debit > 0 && el.credit === el.debit;

                      return (
                        <tr key={el.id}>
                          <td>{index + 2}</td>
                          <td>{moment(el.date).format("DD-MM-YYYY")}</td>
                          <td>
                            {isTransfer && (
                              <>
                                <span className="badge bg-info">Transfer: {el.from} → {el.to}</span>
                                {el.notes && <><br />{el.notes}</>}
                              </>
                            )}
                            {!isTransfer && (el.notes || "-")}
                          </td>
                          <td>{isTransfer ? `${el.to === 'Waqas' ? 'Sir Waqas' : el.to} (from ${el.from === 'Waqas' ? 'Sir Waqas' : el.from})` : ((el.to === 'Waqas' ? 'Sir Waqas' : el.to) || "-")}</td>
                          <td>
                            {el.credit > 0 ? (
                              <CurrencyFormat
                                value={el.credit}
                                displayType="text"
                                thousandSeparator
                                prefix="Rs "
                                suffix="/-"
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{isTransfer ? `${el.from === 'Waqas' ? 'Sir Waqas' : el.from} (to ${el.to === 'Waqas' ? 'Sir Waqas' : el.to})` : ((el.from === 'Waqas' ? 'Sir Waqas' : el.from) || "-")}</td>
                          <td>
                            {el.debit > 0 ? (
                              <CurrencyFormat
                                value={el.debit}
                                displayType="text"
                                thousandSeparator
                                prefix="Rs "
                                suffix="/-"
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <CurrencyFormat
                              value={fBalance}
                              displayType="text"
                              thousandSeparator
                              prefix="Rs "
                              suffix="/-"
                            />
                          </td>
                          <td>
                            <CurrencyFormat
                              value={wBalance}
                              displayType="text"
                              thousandSeparator
                              prefix="Rs "
                              suffix="/-"
                            />
                          </td>
                          <td>
                            <CurrencyFormat
                              value={totalBalance}
                              displayType="text"
                              thousandSeparator
                              prefix="Rs "
                              suffix="/-"
                            />
                          </td>
                          <td>
                            {/* Only show Edit/Delete on the latest entry */}
                            {index === items.length - 1 ? (
                              <>
                                <button
                                  onClick={() => getRecordDetails(el.id)}
                                  className="updt-btn inactive-btn"
                                >
                                  <i className="bi bi-repeat text-success"></i>{" "}
                                  <span className="text-success ms-1">Edit</span>
                                </button>
                                <button
                                  onClick={() => deleteRecord(el.id)}
                                  className="ms-2 inactive-btn"
                                >
                                  <i className="bi bi-trash3 text-danger"></i>{" "}
                                  <span className="text-danger ms-1">Delete</span>
                                </button>
                              </>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Summary Card */}
        {items.length > 0 && (
          <div className="d-flex justify-content-end mt-3">
            <div className="card" style={{ width: "400px" }}>
              <div className="card-body">
                <h6>Final Balances:</h6>
                <div className="d-flex justify-content-between">
                  <span>Faisal Balance:</span>
                  <CurrencyFormat
                    value={fBalance}
                    displayType="text"
                    thousandSeparator
                    prefix="Rs "
                    suffix="/-"
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <span>Waqas Balance:</span>
                  <CurrencyFormat
                    value={wBalance}
                    displayType="text"
                    thousandSeparator
                    prefix="Rs "
                    suffix="/-"
                  />
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <strong>Total Charity:</strong>
                  <strong>
                    <CurrencyFormat
                      value={fBalance + wBalance}
                      displayType="text"
                      thousandSeparator
                      prefix="Rs "
                      suffix="/-"
                    />
                  </strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: { sdate: startDate, edate: endDate },
      onSubmit: fetchCharityRecords,
    });

  // Update form
  const {
    values: updateValues,
    errors: updateErrors,
    touched: updateTouched,
    handleBlur: updateHandleBlur,
    handleChange: updateHandleChange,
    handleSubmit: updateHandleSubmit,
  } = useFormik({
    enableReinitialize: true,
    initialValues: selectedRecord || {
      branch_id: "",
      date: defaultValue,
      type: "",
      person: "",
      amount: "",
      notes: "",
    },
    validationSchema: charitySchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await UserServices.updateCharity(values, packageId);
        if (response.status === 204) {
          toast.success("Updated Successfully!", { autoClose: 3000 });
          fetchCharityRecords({ sdate: startDate, edate: endDate });
          closeButtonRef.current.click();
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to update record", { autoClose: 3000 });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <div className="wrapper">
        <main className="page-content customer-contnent">
          <div className="site-main-design">
            <MenuButton />
            <div className="card">
              <div className="card-header py-3">
                <div className="row">
                  <div className="col-9">
                    <h5 className="mb-0 font-20">Charity Records</h5>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end">
                    <Link to="/add-charity" className="btn btn-primary btn-sm">
                      Add Charity
                    </Link>
                    <Link to={-1} className="btn btn-primary btn-sm ms-2">
                      Go Back
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <form className="row g-3" onSubmit={handleSubmit}>
                  <div className="col-12 col-md-4">
                    <label className="form-label">Start date</label>
                    <input
                      type="date"
                      className={`form-control ${DAteSeted ? "glow" : ""}`}
                      name="sdate"
                      value={values.sdate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label">End date</label>
                    <input
                      type="date"
                      className={`form-control ${DAteSeted ? "glow" : ""}`}
                      name="edate"
                      value={values.edate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      style={{ marginTop: "31px" }}
                      disabled={DAteSeted}
                    >
                      Go
                    </button>
                  </div>

                  {/* Quick Date Buttons */}
                  <div className="col-12">
                    <h5>Quick Dates</h5>
                  </div>
                  <div className="row quick multi-button custom-multi-button">
                    <div className="col-md-4">
                      <label className="form-label d-block">Last</label>
                      <input
                        type="button"
                        onClick={() => setDates("lastYear")}
                        className="generate_report"
                        defaultValue="Year"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("lastQuarter")}
                        className="generate_report"
                        defaultValue="Quarter"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("lastMonth")}
                        className="generate_report"
                        defaultValue="Month"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("lastDay")}
                        className="generate_report"
                        defaultValue="Yesterday"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label d-block">To-Date</label>
                      <input
                        type="button"
                        onClick={() => setDates("toDateYear")}
                        className="generate_report"
                        defaultValue="Year"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("toDateQuarter")}
                        className="generate_report"
                        defaultValue="Quarter"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("toDateMonth")}
                        className="generate_report"
                        defaultValue="Month"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("toDateToday")}
                        className="generate_report"
                        defaultValue="Today"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label d-block">Previous</label>
                      <input
                        type="button"
                        onClick={() => setDates("previous365")}
                        className="generate_report"
                        defaultValue="365 Days"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("previous90")}
                        className="generate_report"
                        defaultValue="90 Days"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("previous30")}
                        className="generate_report"
                        defaultValue="30 Days"
                      />
                      <input
                        type="button"
                        onClick={() => setDates("previous9")}
                        className="generate_report"
                        defaultValue="9 Days"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <Table data={myData} />
          </div>
        </main>
      </div>

      {/* Hidden Button for Modal */}
      <button
        className="btn d-none"
        id="charityModal"
        data-bs-toggle="modal"
        data-bs-target="#updateModal"
      ></button>

      {/* Update Modal */}
      <div
        className="modal fade"
        id="updateModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Charity Transaction</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                ref={closeButtonRef}
              ></button>
            </div>
            <div className="modal-body">
              <form className="row g-3" onSubmit={updateHandleSubmit}>
                <div className="col-md-6">
                  <label className="form-label">
                    Branch <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="branch_id"
                    value={updateValues.branch_id}
                    disabled
                    onChange={updateHandleChange}
                    onBlur={updateHandleBlur}
                  >
                    {myBranches.map((branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="date"
                    value={updateValues.date}
                    onChange={updateHandleChange}
                    onBlur={updateHandleBlur}
                  />
                  {updateErrors.date && updateTouched.date && (
                    <p className="text-danger">{updateErrors.date}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="type"
                    value={updateValues.type}
                    onChange={updateHandleChange}
                    onBlur={updateHandleBlur}
                  >
                    <option value="">Select Type</option>
                    <option value="Credit">Credit</option>
                    <option value="Debit">Debit</option>
                  </select>
                  {updateErrors.type && updateTouched.type && (
                    <p className="text-danger">{updateErrors.type}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Person <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="person"
                    value={updateValues.person}
                    onChange={updateHandleChange}
                    onBlur={updateHandleBlur}
                  >
                    <option value="">Select Person</option>
                    <option value="Faisal">Faisal</option>
                    <option value="Waqas">Waqas</option>
                  </select>
                  {updateErrors.person && updateTouched.person && (
                    <p className="text-danger">{updateErrors.person}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Amount <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    min="0"
                    step="0.01"
                    value={updateValues.amount}
                    onChange={updateHandleChange}
                    onBlur={updateHandleBlur}
                  />
                  {updateErrors.amount && updateTouched.amount && (
                    <p className="text-danger">{updateErrors.amount}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">Notes</label>
                  <input
                    type="text"
                    className="form-control"
                    name="notes"
                    value={updateValues.notes}
                    onChange={updateHandleChange}
                    onBlur={updateHandleBlur}
                  />
                </div>

                <div className="col-12">
                  <button type="submit" className="btn btn-primary w-100">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </>
  );
}
